import { createContext } from 'react';
import { Benefit } from '../../../types/Benefits';

export const BenefitPlanContext = createContext<Partial<Benefit>>({});
